import React from "react";
import * as XLSX from "xlsx";

export const saveTable2ExcelFile = (dataSource, columns, fileNamePrefix) => {
    // 1. 准备数据
    const exportData = dataSource.map(record => {
        const row = {};
        columns.forEach(column => {
            // 跳过不需要导出的列（如操作列）
            if (column.dataIndex && !column.noExport) {
                // 获取列的值
                let value = record[column.dataIndex];

                // 如果有自定义渲染，尝试获取原始值
                if (column.render) {
                    const rendered = column.render(value, record);
                    // 如果渲染结果是React元素，尝试获取其文本内容
                    if (React.isValidElement(rendered)) {
                        value = rendered.props.children || value;
                    } else {
                        value = rendered;
                    }
                    console.log('rendered:', rendered, 'value:', value);
                }

                // 使用 title 或 dataIndex 作为列名
                row[column.title || column.dataIndex] = value;
            }
        });
        return row;
    });
    // 2. 创建工作簿
    const wb = XLSX.utils.book_new();
    // 3. 将数据转换为工作表
    const ws = XLSX.utils.json_to_sheet(exportData);
    // 4. 将工作表添加到工作簿
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    // 5. 导出文件
    fileNamePrefix = fileNamePrefix || '导出数据';
    XLSX.writeFile(wb, `${fileNamePrefix}_${new Date().toLocaleDateString()}.xlsx`);
};